<template>
  <div>
    <el-form :model="editData" :rules="rules" ref="editData" label-position="left" label-width="120px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="报销类型" prop="projectOrOffice" required>
          <el-radio-group v-model="editData.projectOrOffice">
            <el-radio label="1">项目费用</el-radio>
            <el-radio label="2">管理费用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item v-if="editData.projectOrOffice==1" label="报销项目" prop="projectId" required>
          <el-select size="" v-model="editData.projectId" placeholder="请选择报销项目" filterable>
            <el-option
              v-for="item in projectList"
              :key="item.projectId"
              :label="item.projectName"
              :value="item.projectId"
              @click.native="projectChange(item.projectName)"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="报销名目" prop="reimburseType">
          <el-select v-model="editData.reimburseType" placeholder="请选择报销名目">
            <el-option value="1" label="交通费"></el-option>
            <el-option value="9" label="路桥费"></el-option>
            <el-option value="2" label="油费"></el-option>
            <el-option value="3" label="招待费"></el-option>
            <el-option value="4" label="住宿费"></el-option>
            <el-option value="5" label="餐补"></el-option>
            <el-option value="6" label="办公费"></el-option>
            <el-option value="11" label="福利费"></el-option>
            <el-option value="10" label="礼品费" :disabled="editData.projectOrOffice==1"></el-option>
            <el-option value="8" label="其他" :disabled="editData.projectOrOffice==1"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="12" v-if="editData.projectOrOffice==1&&editData.reimburseType==3">
        <el-form-item label="所属招待" prop="costReportId">
          <el-select size="" v-model="editData.costReportId" placeholder="请选择所属招待"
                      filterable focus="getAllCostReport">
            <el-option
              v-for="item in costReports"
              :key="item.costReportId"
              :label="item.projectName"
              :value="item.costReportId"
              :disabled="item.isSubmit === 3">
              <span style="float: left">{{ item.projectName }}&nbsp&nbsp{{item.projectIden}}</span>
              <el-tag v-if="item.isSubmit === 3" size="mini" effect="dark" type="info"
                style="float: right; margin-top: 8px">
                存在报销
              </el-tag>
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item label="报销金额" prop="reimburseMoney">
      <el-input v-model="editData.reimburseMoney" placeholder="请输入报销金额" maxlength="12">
        <template slot="append">{{ getDigitUppercase }}</template>
      </el-input>
    </el-form-item>

    <el-form-item label="费用产生时间" prop="spendTime">
      <el-date-picker
          v-model="editData.spendTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          type="datetime"
          placeholder="请选择费用产生时间">
      </el-date-picker>

    </el-form-item>
    <el-row :gutter="20" v-if="editData.reimburseType==1||editData.reimburseType==2">
      <el-col :span="12">
        <el-form-item label="出发地" prop="originAddress">
          <el-input v-model="editData.originAddress" placeholder="请输入出发地">
          </el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="目的地" prop="endAddress">
          <el-input v-model="editData.endAddress" placeholder="请输入目的地">
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="费用事由" prop="remarks">
      <el-input size="" type="textarea" v-model="editData.remarks"
                placeholder="请输入费用事由">
      </el-input>
    </el-form-item>
    <el-Form-item>
      <el-button type="warning" @click="editReimburseId('editData')">修改报销项</el-button>
    </el-Form-item>
  </el-form>
  </div>


</template>

<script>
import {digitUppercase, isNum} from "../../../util";
import {requestReimburseEdit, requestCostReportDetail, requestAllCostReport} from "../../../api";
export default {
  name: "EditReimburse",
  props: {
    editData: {},
    projectList: [],
  },
  data() {
    const validatePrice = (rule, value, callback) => {
      if (!value) {
        callback(new Error("金额不能为空"));
      } else if (!isNum(value)) {
        callback(new Error("请输入正确格式的金额"));
      } else if (value.split(".").length > 2) {
        callback(new Error("请输入正确格式的金额")); //防止输入多个小数点
      } else if (value.indexOf(".") > -1 && value.substring(value.indexOf(".") + 1).length > 2) {
        callback(new Error("最大保留两位小数"));
      } else if (value.length > 12) {
        callback(new Error("长度最大12个字符"))
      } else {
        this.editData.reimburseMoney = value
        callback();
      }
    };
    return {
      detailShow: false,
      costReport: {},
      costReports: [],
      rules: {
        reimburseMoney: [
          {required: true, validator: validatePrice, trigger: 'blur'},
        ],
        reportSubject: [
          {required: true, message: '请输入申请事由', trigger: 'blur'},
          {max: 500, message: '长度最大500个字符', trigger: 'blur'}
        ],
        projectId: [
          {required: true, message: '请选择报销项目', trigger: 'blur'},
        ],
        reimburseType: [
          {required: true, message: '请选择报销名目', trigger: 'blur'},
        ],
        spendTime: [
          {required: true, message: '请选择费用产生时间', trigger: 'blur'},
        ],
        costReportId: [
          {required: true, message: '请选择所属招待', trigger: 'blur'},
        ],
        remarks: [
          {max: 500, message: '长度最大500个字符', trigger: 'blur'}
        ],
      },
    }
  },
  computed: {
    getDigitUppercase() {
      return digitUppercase(this.editData.reimburseMoney)
    },
  },
  created() {
    this.getAllCostReport()
  },
  methods: {
    editReimburseId(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editData.projectOrOffice == 2) {
            this.editData.projectId = ""
            this.editData.projectName = ""
          }
          if (!(this.editData.projectOrOffice == 1 && this.editData.reimburseType == 3)) {
            this.editData.costReportId = ""
          }
          requestReimburseEdit(this.editData).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.$emit("refresh")
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          return false;
        }
      })
    },
    getCostDetail(costReportId) {
      requestCostReportDetail({costReportId:costReportId}).then(res => {
        if (res.code === 200) {
          if (res.object) {
            this.costReports.push(res.object.detail)
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getAllCostReport() {
      requestAllCostReport({}).then(res => {
        if (res.code === 200) {
          if (res.object) {
            this.costReports = res.object

//            if (this.editData.costReportId) {
//              this.getCostDetail(this.editData.costReportId)
//            }
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    handleDetail(item) {
      console.log(item)
      this.detailShow = true
      this.costReport = item
    },
    handleDetailConfirm() {
      this.detailShow = false
      this.ruleForm.costReportId = this.costReport.costReportId
    },
    projectChange(projectName) {
      this.editData.projectName = projectName
    },
  }
}
</script>

<style scoped>

</style>>
